import { Checkbox, TextInputProps } from 'imaginarity-react-ui';
import * as React from 'react';
import { BaseEditItem } from '../GeneralPostEdit';
import { useGPEState } from '../Helpers/UseGPEState';

export interface EditBooleanProps<T> extends TextInputProps {
    getter: (value: T) => boolean | undefined;
}

const EditBoolean = <T extends BaseEditItem = BaseEditItem>(props: EditBooleanProps<T>) => {
    const { getter } = props;
    const { value: val, setValue: setVal } = useGPEState(getter);

    const toggleValue = () => {
        setVal(v => !v);
    }

    return (
        <div>
            <Checkbox selected={val} onClick={toggleValue} label={""} />
        </div>
    );
}

export default EditBoolean;
